import { getDateString, moveModal } from "../../utils/Utils";
import TeacherConstant from "../../utils/constants/TeacherConstant";
import proxy from "../../utils/Proxy";
import { useState } from "react";
import UserLessonListModal from "./UserLessonListModal";

let LessonModifyModal = (props) => {
    let [childModalOpened, setChildModalOpened] = useState(false)
    let getTeacherName = () => {
        let teacherid = props.lesson.teacherid;
        if (typeof props.data.teachers[teacherid] === "undefined") {
            return "선생님 정보 없음";
        }
        let teacher = props.data.teachers[teacherid];
        return TeacherConstant.major_symbol[teacher.major] + teacher.name;
    }
    let onModifyDone = (_) => {
        let act = props.lesson.is_done ? "미완료" : "완료"
        let dialogResult = window.confirm("레슨 " + act + " 처리하시겠습니까?")
        if (dialogResult) {
            let body = { done: !props.lesson.is_done }
            proxy.put("/adminapi/lessons/" + props.lesson.lessonid, body).then(_ => {
                window.alert("레슨 처리가 완료되었습니다.");
                props.setNeedUpdate(true)
                props.onCloseClick(null);
            }).catch(error => {
                let message = error.response.data.message;
                return alert(message);
            })
        }
    }
    let onCancel = (_) => {
        let dialogResult = window.confirm("레슨을 취소하시겠습니까?")
        if (dialogResult) {
            if (props.isAdmin) {
                proxy.delete("/adminapi/lessons/" + props.lesson.lessonid).then(_ => {
                    window.alert("레슨 취소가 완료되었습니다.")
                    props.setNeedUpdate(true)
                    props.onCloseClick(null)
                }).catch(error => {
                    let message = error.response.data.message;
                    return alert(message)
                })
            } else {
                proxy.delete("/api/lessons/" + props.lesson.lessonid).then(_ => {
                    window.alert("레슨 취소가 완료되었습니다.")
                    props.setNeedUpdate(true)
                    props.onCloseClick(null)
                    props.setNeedInfoRefresh(true)
                }).catch(error => {
                    let message = error.response.data.message;
                    return alert(message)
                })
            }
        }
    }
    let onLessonListButtonClick = (_) => {
        setChildModalOpened(true);
    }

    return props.opened ? (<div className="modal-container">
        <div className="modal" id="lesson-modify-modal">
            <div className="modal-content-container">
                <div className="modal-header" onMouseDown={e => moveModal(e, "lesson-modify-modal")}>
                    <p className="modal-title">
                        레슨 {props.isAdmin ? "관리" : "정보"}
                    </p>
                    <div className="modal-close-button" onClick={props.onCloseClick}></div>
                </div>
                <div className="modal-content">
                    <ul>
                        <div className="modal-content-item">
                            <li className="modal-content-text">
                                레슨 번호: {props.lesson.lessonid}
                            </li>
                        </div>
                        <div className="modal-content-item">
                            <li className="modal-content-text">
                                수강생 이름: {props.lesson.username}
                            </li>
                            {props.lesson.userid !== null && props.isAdmin ?
                                (<>
                                    <div className="user-lesson-list-button"
                                        onClick={onLessonListButtonClick.bind(this)}>
                                        <p>레슨 목록</p>
                                    </div>
                                    {childModalOpened ? (<UserLessonListModal
                                        setOpened={setChildModalOpened.bind(this)}
                                        opened={childModalOpened}
                                        userid={props.lesson.userid}
                                        username={props.lesson.username}
                                        data={props.data}
                                        setNeedUpdate={props.setNeedUpdate} //이거 없어도 작동됨.
                                    // setNeedUpdate는 시간표 업데이트를 위해 끼워넣은것
                                    />)
                                        : null}</>)
                                : null}
                        </div>
                        {props.lesson.contact ?
                            <div className="modal-content-item">
                                <li className="modal-content-text">
                                    수강생 전화번호: {props.lesson.contact}
                                </li>
                            </div> : null}
                        <div className="modal-content-item">
                            <li className="modal-content-text">
                                레슨 선생님: {getTeacherName()}
                            </li>
                        </div>
                        <div className="modal-content-item">
                            <li className="modal-content-text">
                                레슨 일시: {getDateString(new Date(props.lesson.due)) + " " + props.lesson.hour + "시"}
                            </li>
                        </div>
                        <div className="modal-content-item">
                            <li className="modal-content-text">
                                레슨 완료 여부: {props.lesson.is_done ? "완료" : "미완료"}
                            </li>
                        </div>
                    </ul>
                </div>
                <div className="modal-footer">
                    <div className="modal-footer-button-container">
                        {props.isAdmin ?
                            (props.lesson.is_done ?
                                (<div className="modal-button" onClick={onModifyDone}>
                                    <p>레슨 미완료 처리하기</p>
                                </div>) :
                                (<>
                                    <div className="modal-button" onClick={onModifyDone}>
                                        <p>레슨 완료</p>
                                    </div>
                                    <div className="modal-button" onClick={onCancel}>
                                        <p>레슨 취소</p>
                                    </div>
                                </>)) :
                            (props.lesson.is_done ?
                                null :
                                <div className="modal-button" onClick={onCancel}>
                                    <p>레슨 취소</p>
                                </div>)
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>) : null;
}
export default LessonModifyModal;